export default "__VITE_ASSET__208f596c__"